import { FullscreenPage, StatBar } from '@/components/ui';
import { useCharacterStore } from '@/engine/state';

export function CharacterPage() {
  const p = useCharacterStore((s) => s.personaje);
  const setNombre = useCharacterStore((s) => s.setNombre);

  return (
    <FullscreenPage
      titulo={p.nombre}
      subtitulo={`Nivel ${p.nivel} · ${p.xp}/${p.xpParaSiguienteNivel} XP`}
    >
      <div className="grid md:grid-cols-2 gap-5 max-w-4xl mx-auto">
        <section className="space-y-4">
          <label className="flex flex-col gap-1.5 fluid-xs text-ash-400 font-ui">
            <span className="uppercase tracking-widest">Nombre</span>
            <input
              type="text"
              value={p.nombre}
              onChange={(e) => setNombre(e.target.value)}
              className="bg-ash-900 border border-ash-700 rounded px-3 py-2 text-ash-100 focus:outline-none focus:border-moss-500 fluid-base"
            />
          </label>

          <div className="space-y-3">
            <StatBar label="Vida" valor={p.stats.vida} max={p.stats.vidaMax} color="ember" />
            <StatBar label="Mana" valor={p.stats.mana} max={p.stats.manaMax} color="mystic" />
          </div>

          <dl className="grid grid-cols-2 gap-x-4 gap-y-1 fluid-sm">
            {(
              [
                ['Empatía', p.stats.empatia],
                ['Valentía', p.stats.valentia],
                ['Astucia', p.stats.astucia],
                ['Resistencia', p.stats.resistencia],
                ['Vínculo con Pipo', p.stats.vinculo],
              ] as const
            ).map(([k, v]) => (
              <div key={k} className="flex justify-between border-b border-ash-900 py-1">
                <dt className="text-ash-500">{k}</dt>
                <dd className="tabular-nums text-ash-200">{v}</dd>
              </div>
            ))}
          </dl>
        </section>

        <section>
          <header className="mb-2">
            <h2 className="text-display fluid-lg text-ash-100">Inventario</h2>
            <p className="fluid-xs text-ash-500 font-ui uppercase tracking-widest mt-0.5">
              {p.inventario.length} objeto{p.inventario.length !== 1 ? 's' : ''}
            </p>
          </header>
          {p.inventario.length === 0 ? (
            <p className="text-narrative italic text-ash-500 fluid-sm">
              Franco no lleva nada encima. El fuego se comió todo.
            </p>
          ) : (
            <ul className="space-y-2">
              {p.inventario.map((it) => (
                <li key={it.id} className="border-l-2 border-moss-700/60 pl-3">
                  <p className="text-ash-200 fluid-base">
                    {it.nombre}
                    {it.cantidad > 1 && (
                      <span className="text-ash-500"> ×{it.cantidad}</span>
                    )}
                  </p>
                  {it.descripcion && (
                    <p className="fluid-sm text-ash-500">{it.descripcion}</p>
                  )}
                </li>
              ))}
            </ul>
          )}
        </section>
      </div>
    </FullscreenPage>
  );
}
